import { Backdrop, CircularProgress } from "@mui/material";

const Loader = ({ loading }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress size={60} color="inherit" />
    </Backdrop>
  );
};

export default Loader;
